//https://www.youtube.com/watch?v=uyW48EQge-8&list=PL4cSPhAvl8xUOt7RrCPEwzVPs8RXWsGzg&index=4&ab_channel=FunOfHeuristic
export class Movie {

  Id: number | undefined;
  Name: string;
  Earning: number;
  ReleaseDate: Date;
  UserName: string;

  constructor(
    name?: string,
    earning?: number,
    releaseDate?: Date,
    userName?: string
  ) {
    this.Name = name || '';
    this.Earning = earning || 0;
    this.ReleaseDate = releaseDate || new Date();
    this.UserName = userName || 'Itai Roded';
  }

}
